import isArray from 'onyx-common/isArray'

const normalizeArray = (arr) => {
  if (isArray(arr)) return arr

  return [arr]
}

export default normalizeArray
